import {ServiceTypeEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";
import {useCallback, useEffect, useState} from "react";

export type BaseServiceTypeMultiSelectProps = Omit<BaseEntityMultiSelectProps<ServiceTypeEntity>, 'nameMapper'> & {
  useAbbreviation?: boolean;
};

export const BaseServiceTypeMultiSelect = (props: BaseServiceTypeMultiSelectProps) => {
  const {useAbbreviation = true, entities, ...rest} = props;

  const [sortedData, setSortedData] = useState(entities);

  // name mapper
  const nameMapper = useCallback(
    (e: ServiceTypeEntity) => {
      let name: string
      if (useAbbreviation) {
        name = e.abbr ?? e.name;
      } else {
        name = e.name;
      }

      if (typeof e.operatorIsPickup !== 'undefined' && !e.operatorIsPickup) {
        name += " (D)"
      } else {
        name += " (P)"
      }

      return name
    },
    [useAbbreviation]
  );

  // sort service types by display name
  useEffect(() => {
    const sortedServiceTypes = entities.sort((a, b) =>
      nameMapper(a).localeCompare(nameMapper(b))
    );
    setSortedData(sortedServiceTypes);
  }, [entities, nameMapper]);

  return <BaseEntityMultiSelect entities={sortedData} nameMapper={nameMapper} {...rest} />;
};
